import { CA_MARKET, US_MARKET } from '../constants';

const getMarket = (host = typeof window !== 'undefined' ? window.location.hostname : '') => {
  if (host.includes('audi.ca')) return CA_MARKET;
  return US_MARKET;
};

export default getMarket;
